export default __webpack_public_path__ + "static/media/timelapse.34b6c3bc.svg";